import country from '../../helpers/worldMapByCountry';
import { slugFromCC } from 'tf-post-parser';
import Link from 'next/link';

export default function WorldMap() {
  const mapCountries = country.map(country => {
    const countryPath = (
      <path
        key={country.id}
        d={country.shape}
        className={`tw-fill-gray-300 dark:tw-fill-gray-700 tw-stroke-gray-100 dark:tw-stroke-gray-900 hover:tw-fill-primary-800  dark:hover:tw-fill-primary-400`}
      />
    );
    return (
      <Link
        key={country.id}
        href={`/destinations/${slugFromCC(country.id.toLowerCase())}`}
        prefetch={false}
      >
        {countryPath}
      </Link>
    );
  });
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="200"
      width="300"
      viewBox="0 0 2000 1001"
      className="tw-hidden sm:tw-block tw-h-72 md:tw-h-96 xl:tw-h-[28rem] tw-w-full"
    >
      {mapCountries}
    </svg>
  );
}
